import React from 'react'
import CustomCalendarManagement from '../../admin/CustomCalendarManagement'
import V3DataRouteShell from '../data/V3DataRouteShell'

export default function V3CustomCalendarManagementPage() {
  return (
    <V3DataRouteShell>
      <CustomCalendarManagement />
    </V3DataRouteShell>
  )
}

